import { useRef, useEffect } from 'react';

const initialValue = Symbol();
/**
 * An effect that only runs on a value's change, rather than bound to component lifecycle.
 *
 * @param callback The effect to be called on value changed. First argument is the
 *   previous instance of value. Does not take a cleanup function, as this effect should
 *   not be bound to component lifecycle.
 *
 * @param value The value to be watched.
 */
function useOnValueChangeEffect(callback, value) {
    const previousRef = useRef(initialValue);
    useEffect(() => {
        if (previousRef.current !== initialValue) {
            callback(previousRef.current);
        }
        previousRef.current = value;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
}

export { useOnValueChangeEffect };
//# sourceMappingURL=use-on-value-change-effect.js.map
